export function isBetween(value: number, min: number, max: number): boolean {
    return value >= min && value <= max;
}

export function getIntervalStepsNb(max: number, min = 0, stepSize = 1): number {
    return Math.floor((max - min) / stepSize);
}
